module.exports = __webpack_public_path__ + "static/img/warranty.abd0a2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/warranty.png
// module id = x9RT
// module chunks = 1